import { createSelector } from '@ngrx/store';
import { creditCardsState } from '../root';

export const isPayInStoreSelected = createSelector(creditCardsState, (creditCards) => creditCards.activeCardId === OLO.Enums.PAYMENT_VENDOR_SERVICE.PAY_IN_STORE);
